import React, { forwardRef } from 'react'
import { Select as AntdSelect, SelectProps, RefSelectProps } from 'antd'

/**
 * The ANTD half of the `src/antd/Select` seam — the previous
 * `src/antd/Select.tsx`, MOVED, not rewritten. `./index.tsx` is the dispatcher.
 *
 * Never edit this file to fix something you saw with the design toggle ON: it
 * is what every customer renders today, and `../__tests__/
 * select-seam-parity.test.tsx` holds it node for node. The shadcn rendering
 * lives in `./Select.shadcn`.
 *
 * The `getPopupContainer` default below is the reason this seam SHADOWS antd
 * rather than re-exporting it: the popup is rendered inline, in the trigger's
 * parent, instead of portalled to `document.body`. `./index.tsx` and
 * `./Select.shadcn` both say what follows from that.
 *
 * The generic component type this is cast to lives in `./types` (`TSelect`),
 * shared with the dispatcher; the long note there explains what the cast costs
 * and which call site exercises it.
 */
const Select = forwardRef<RefSelectProps, SelectProps>((props, ref) => (
  <AntdSelect
    ref={ref}
    getPopupContainer={(trigger) => trigger.parentElement}
    {...props}
  />
))

Select.displayName = 'Select'

export { Select }
